import { useUrlFilters } from '@/hooks';
import { parseSuggestedFaqFilters } from '../helpers';

export const useSuggestedFaqFilters = () => useUrlFilters(parseSuggestedFaqFilters);
